export default __webpack_public_path__ + "static/media/profilepic.00dfed55.webp";